import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83a7daa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "pages"
}
const _hoisted_4 = { key: 1 }


import {commitVideoDuration, RecordedContentVO} from "@/apis/recorded";
import {CoursePlanPartVO} from "@/apis/course";
import {pageMap} from "@/components/pages";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainRecordedContentItem',
  props: {
    content: {},
    level: {},
    part: {}
  },
  setup(__props: any) {

const props = __props

// 上报视频观看时长
const handleCountTime = ({pageId, time}) => {
  commitVideoDuration({
    duration: time,
    recordedPageId: pageId,
    courseId: props.part.userCoursePlanPart.courseId,
    partId: props.part.id
  })
}

return (_ctx: any,_cache: any) => {
  const _component_MainRecordedContentItem = _resolveComponent("MainRecordedContentItem", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['section','section' + _ctx.level])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['content-title', 'title' + _ctx.level]),
      id: 'content' + _ctx.content.id
    }, [
      _createElementVNode("a", {
        href: '#content' + _ctx.content.id,
        class: "header-anchor"
      }, "#", 8, _hoisted_2),
      _createTextVNode(" " + _toDisplayString(_ctx.content.title), 1)
    ], 10, _hoisted_1),
    (_ctx.content.pages?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.pages, (page) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(pageMap)[page.page.type]), {
              page: page.page,
              userPage: page.userPage,
              courseId: _ctx.part.userCoursePlanPart.courseId,
              partId: _ctx.part.id,
              pageId: page.id,
              key: 'page' + page.id,
              onCountTime: handleCountTime
            }, null, 40, ["page", "userPage", "courseId", "partId", "pageId"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.content.children?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.children, (item) => {
            return (_openBlock(), _createBlock(_component_MainRecordedContentItem, {
              content: item,
              level: _ctx.level + 1,
              part: _ctx.part,
              key: 'content' + item.id
            }, null, 8, ["content", "level", "part"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})